import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { b2bGetLists, b2bCreateList, b2bDeleteList } from '../../../lib/adminApi';
import AdminSidebar from '../../../components/AdminSidebar';

const NAVY = '#0a2540'; const ORANGE = '#F37428'; const BLUE = '#0176CE';

export default function B2BLists() {
  const navigate = useNavigate();
  const [lists, setLists] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showNew, setShowNew] = useState(false);
  const [form, setForm] = useState({ list_name: '', description: '' });
  const [saving, setSaving] = useState(false);

  function load() {
    setLoading(true);
    b2bGetLists().then(r => { setLists(r.lists || []); setLoading(false); }).catch(() => setLoading(false));
  }

  useEffect(() => { load(); }, []);

  async function handleCreate(e) {
    e.preventDefault(); setSaving(true);
    try {
      const r = await b2bCreateList(form);
      navigate(`/admin/b2b/lists/${r.list_id}`);
    } catch (err) { alert(err.message); setSaving(false); }
  }

  return (
    <div style={s.page}>
      <AdminSidebar active="b2b-lists" />
      <main style={s.main}>
        <div style={s.topRow}>
          <h1 style={s.title}>Lists</h1>
          <div style={{ display: 'flex', gap: 8 }}>
            <button style={s.builderBtn} onClick={() => navigate('/admin/b2b/lists/builder')}>⚡ List Builder</button>
            <button style={s.primaryBtn} onClick={() => setShowNew(true)}>+ New List</button>
          </div>
        </div>

        {showNew && (
          <div style={s.modal}>
            <div style={s.modalBox}>
              <h2 style={{ margin: '0 0 16px', color: NAVY, fontSize: 18 }}>New Contact List</h2>
              <form onSubmit={handleCreate} style={{ display: 'grid', gap: 12 }}>
                <input required style={s.inp} placeholder="List Name *" value={form.list_name} onChange={e => setForm(f => ({ ...f, list_name: e.target.value }))} />
                <textarea style={{ ...s.inp, height: 80, resize: 'vertical' }} placeholder="Description" value={form.description} onChange={e => setForm(f => ({ ...f, description: e.target.value }))} />
                <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                  <button type="button" style={s.cancelBtn} onClick={() => setShowNew(false)}>Cancel</button>
                  <button type="submit" style={s.primaryBtn} disabled={saving}>{saving ? 'Saving…' : 'Create'}</button>
                </div>
              </form>
            </div>
          </div>
        )}

        <div style={s.grid}>
          {loading && <div style={{ color: '#64748b' }}>Loading…</div>}
          {!loading && lists.length === 0 && <div style={{ color: '#94a3b8' }}>No lists yet</div>}
          {lists.map(l => (
            <div key={l.list_id} style={s.listCard}>
              <div style={s.listCardTop}>
                <Link to={`/admin/b2b/lists/${l.list_id}`} style={{ color: NAVY, fontSize: 15, fontWeight: 600, textDecoration: 'none' }}>{l.list_name}</Link>
                <button style={s.deleteBtn} onClick={async () => { if (confirm('Delete list?')) { await b2bDeleteList(l.list_id); load(); } }}>Delete</button>
              </div>
              {l.description && <div style={{ color: '#64748b', fontSize: 12, marginTop: 4 }}>{l.description}</div>}
              <div style={s.listMeta}>
                <span style={s.metaBadge}>{l.member_count} contacts</span>
                <span style={{ color: '#94a3b8', fontSize: 11 }}>{new Date(l.created_on_utc).toLocaleDateString()}</span>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

const s = {
  page: { display: 'flex', minHeight: '100vh', fontFamily: "'Inter', system-ui, sans-serif" },
  main: { flex: 1, background: '#f0f5fb', padding: '36px 40px', overflowY: 'auto' },
  topRow: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 },
  title: { color: NAVY, fontSize: 24, fontWeight: 700, margin: 0 },
  primaryBtn: { background: ORANGE, color: '#fff', border: 'none', borderRadius: 8, padding: '8px 18px', fontSize: 13, fontWeight: 600, cursor: 'pointer' },
  builderBtn: { background: '#fff', color: BLUE, border: `1px solid ${BLUE}`, borderRadius: 8, padding: '8px 18px', fontSize: 13, fontWeight: 600, cursor: 'pointer' },
  cancelBtn: { background: '#f1f5f9', color: '#64748b', border: 'none', borderRadius: 8, padding: '8px 18px', fontSize: 13, cursor: 'pointer' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 16 },
  listCard: { background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, padding: 20, boxShadow: '0 1px 3px rgba(0,0,0,0.05)' },
  listCardTop: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  listMeta: { display: 'flex', alignItems: 'center', gap: 10, marginTop: 12 },
  metaBadge: { background: 'rgba(1,118,206,0.08)', color: BLUE, borderRadius: 4, padding: '2px 8px', fontSize: 11, fontWeight: 600 },
  deleteBtn: { background: 'transparent', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: 12 },
  modal: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100 },
  modalBox: { background: '#fff', borderRadius: 12, padding: '28px 32px', width: 440, boxShadow: '0 20px 60px rgba(0,0,0,0.2)' },
  inp: { padding: '8px 12px', border: '1px solid #e2e8f0', borderRadius: 8, fontSize: 13, width: '100%', boxSizing: 'border-box' },
};
